/* tracking.js */

// GTM merges every push into one persistent model, so parameter objects of
// earlier events survive until they are overwritten. Null them out on each push.
const EVENT_NAMES = ['faq_category_click', 'faq_question_open', 'cta_click'];

function pushEvent(name, params) {
    let payload = {
        event: 'gaEvent',
        event_name: name,
    };

    for (const key of EVENT_NAMES) {
        payload[key] = key === name ? params : null;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
}

function categoryNameOf(el) {
    let categoryEl = el.closest('[data-faq-category]');

    return categoryEl ? categoryEl.dataset.faqCategory : '';
}

// a category only becomes active if it is hidden right now
function trackCategoryClick(trigger) {
    let container = trigger.closest('.faq-container');

    if (!container) {
        return;
    }

    let target = container.querySelector('.faq-category-el[data-faqid="' + trigger.dataset.cattoggles + '"]');

    if (!target || !target.classList.contains('hidden')) {
        return;
    }

    pushEvent('faq_category_click', {
        faq_category: trigger.dataset.faqCategory || '',
    });
}

// a hidden answer is about to be opened, a visible one about to be closed
function trackQuestionOpen(accordionEl) {
    let body = accordionEl.querySelector('.faq-accordion-body');
    let button = accordionEl.querySelector('.faq-accordion-header-button');

    if (!body || !button || !body.classList.contains('hidden')) {
        return;
    }

    pushEvent('faq_question_open', {
        faq_category: categoryNameOf(accordionEl),
        faq_question: button.dataset.faqQuestion || button.textContent.trim(),
    });
}

function trackCtaClick(link) {
    pushEvent('cta_click', {
        cta_text: link.textContent.trim(),
        cta_location: link.dataset.ctaLocation || 'content',
    });
}

export default function () {
    // capture phase runs before faqController toggles, so the pre-click state is still readable
    document.addEventListener('click', (event) => {
        if (!(event.target instanceof Element)) {
            return;
        }

        let cta = event.target.closest('.btn-primary');

        if (cta) {
            trackCtaClick(cta);
            return;
        }

        let categoryBtn = event.target.closest('.category-filter-button');

        if (categoryBtn) {
            trackCategoryClick(categoryBtn);
            return;
        }

        let accordionEl = event.target.closest('.faq-accordion-el');

        if (accordionEl && event.target.closest('.faq-accordion-header-button, .icons-ArrowUpIcon')) {
            trackQuestionOpen(accordionEl);
        }
    }, true);
}
